import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';
import UserLayout from '@components/layout/UserLayout.tsx';
import OrderDetail from '@features/client/orders/OrderDetail.tsx';

const paramSchema = z.object({
  orderId: z.coerce.number().positive(),
});

export const Route = createFileRoute('/c/$orgId/$portalId/orders/$orderId')({
  params: {
    parse: v => paramSchema.parse(v),
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  return (
    <UserLayout>
      <OrderDetail orderId={orderId} />
    </UserLayout>
  );
}
